import React, { useRef, useState, useEffect, useCallback, act } from 'react';
import * as Icons from 'react-icons/fa';
import { API, graphqlOperation } from 'aws-amplify';
import { getNotificationCount, listNotifications } from '../../generated/graphql/queries';
import { clearNotificationCount } from '../../generated/graphql/mutations';
import { onNotificationCreated } from '../../generated/graphql/subscriptions';
import Spinner from '../Spinner';
import NotificationRow from '../NotificationRow';
import { useUser } from '../../contexts/userContext';
import { useFocus } from '../../contexts/focusContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
// import { useNotifications } from '../../helpers/useNotifications';
import { useNotifications } from '../../contexts/notificationContext';
import { useHistory } from 'react-router-dom';
import Switch from 'react-switch';
const USE_VOLUNTEER_VIEW = 'USE_VOLUNTEER_VIEW';
const changeFavicon = (hasUnread = false) => {
  const link = document.querySelector('link[rel="icon"]');
  // console.log('link', link, hasUnread);
  if (link && hasUnread === true) {
    link.setAttribute('href', '/p1591-icon-unread.svg');
  } else if (link) {
    link.setAttribute('href', '/p1591-icon-read.svg');
  }
};

export const notificationGroups = [
  {
    label: 'Cases',
    // icon: <Icons.FaBriefcase className="text-pursuit-gray text-xl mr-2" />,
    icon: (
      <FontAwesomeIcon
        icon={icon({ name: 'briefcase-blank', style: 'solid' })}
        className="text-pursuit-gray text-xl mr-2"
      />
    ),
    types: [
      'CASE_RESUBMITTED',
      'CASE_SUBMITTED',
      'CASE_APPROVED',
      'CASE_REJECTED',
      'CASE_RETURNED',
      'CASE_FILE_DOWNLOADED',
      'CASE_UNASSIGNED',
      'CASE_ASSIGNED',
      'CASE_SUBMITTED_AFTER_RETURN',
      'CASE_DELETED',
      'CASE_NULLIFIED',
    ],
    adminOnly: false,
  },
  {
    label: 'Messages',
    // icon: <Icons.FaRegCommentDots className="text-pursuit-gray text-xl mr-2" />,
    icon: (
      <FontAwesomeIcon icon={icon({ name: 'envelope', style: 'solid' })} className="text-pursuit-gray text-xl mr-2" />
    ),
    types: ['MESSAGE_RECEIVED', 'GENERIC'],
    adminOnly: false,
  },
  {
    label: 'Users',
    // icon: <Icons.FaRegUser className="text-pursuit-gray text-xl mr-2" />,
    icon: <FontAwesomeIcon icon={icon({ name: 'user', style: 'solid' })} className="text-pursuit-gray text-xl mr-2" />,
    types: ['AWARD_THRESHOLD_REACHED', 'CERTIFICATION_SUBMITTED', 'LEO_USER_ONBOARDED', 'USER_ONBOARDED', 'USER_DELETED', 'USER_DISABLED', 'LEO_USER_DISABLED', 'LEO_USER_DELETED'],
    adminOnly: true,
  },
];

const Notifications = ({ limit = 50, useVolunteerView = true }) => {
  const { user, isAdmin } = useUser();
  const { isFocused } = useFocus();
  const {
    markAsRead,
    markAsUnread,
    notificationCount,
    fetchNotifications,
    fetchNewestNotifications,
    notifications,
    queryNotificationCount,
    resetNotifications,
    resetNextToken,
    loading,
    unreadNotifications,
    fetchUnreadNotifications,
  } = useNotifications();
  // } = {};

  const history = useHistory();

  const [dropdownIsActive, setDropdownIsActive] = useState(false);
  // const [notificationCount, setNotificationCount] = useState(0);
  // const [notifications, setNotifications] = useState([]);
  // const [nextToken, setNextToken] = useState(null);

  // const [loading, setLoading] = useState(false);

  const clickOutsideRef = useRef(null);
  const fetchAttemptedRef = useRef({});

  const userId = user?.id;

  const [activeTab, setActiveTab] = useState(notificationGroups[0].label);
  const [activeTabNotifications, setActiveTabNotifications] = useState([]);

  const [onlyShowUnread, setOnlyShowUnread] = useState(false);

  const toggleOnlyShowUnread = () => {
    setOnlyShowUnread(!onlyShowUnread);
  };

  // const checkForVolunteerView = () => {
  //   const useVolunteerSavedPref = localStorage.getItem(USE_VOLUNTEER_VIEW);

  //   if (useVolunteerSavedPref && useVolunteerSavedPref.toLowerCase() === 'true') {
  //     return true;
  //   }

  //   return false;
  // };

  const userNotificationGroups = notificationGroups.filter(group => {
    // Only include groups that are not admin-only or if the user is an admin

    return !group.adminOnly || (group.adminOnly && isAdmin && !useVolunteerView);
  });

  // const queryNotificationCount = useCallback(async () => {
  //   try {
  //     const {
  //       data: { getNotificationCount: data = null },
  //     } = await API.graphql(graphqlOperation(getNotificationCount));
  //     console.log('getNotificationCount data', data);
  //     if (!data) {
  //       // setNotificationCount(0);
  //       return;
  //     }
  //     const { count } = data;
  //     // setNotificationCount(count || 0);
  //   } catch (error) {
  //     console.error('Error fetching notification count: ', error);
  //   }
  // }, []);

  const queryNotifications = useCallback(
    async ({ loadNext = false, types } = {}) => {
      // console.log('queryNotifications called with:', { loadNext, types });
      await fetchNotifications({ limit, types });
      // setLoading(true);

      // try {
      //   const prevNotifications = loadNext && notifications && nextToken ? [...notifications] : [];

      //   const params = { limit };

      //   if (loadNext && nextToken) {
      //     params.nextToken = nextToken;
      //   }

      //   const {
      //     data: { listNotifications: result = null },
      //   } = await API.graphql(graphqlOperation(listNotifications, params));

      //   const newNotifications = result.items;

      //   const updatedNotifications = [...prevNotifications, ...newNotifications];
      //   console.log('updatedNotifications', updatedNotifications);

      //   setNotifications(updatedNotifications);
      //   setNextToken(result.nextToken || null);
      //   setLoading(false);

      //   // setNotificationCount(0);

      //   try {
      //     await API.graphql(graphqlOperation(clearNotificationCount));
      //   } catch (error) {
      //     console.error('Error clearing notification count: ', error);
      //   }
      // } catch (error) {
      //   console.error('Error fetching notifications: ', error);
      // }

      // setLoading(false);
    },
    [limit, fetchNotifications]
  );

  const loadMoreNotifications = useCallback(() => {
    if (activeTab) {
      // Find the types for the active tab
      const activeTypes = notificationGroups.find(group => group.label === activeTab).types;
      queryNotifications({ loadNext: true, types: activeTypes });
    } else {
      queryNotifications({ loadNext: true });
    }
  }, [activeTab]);

  useEffect(() => {
    if (isFocused) {
      queryNotificationCount();
    }
  }, [queryNotificationCount, userId, isFocused]);

  useEffect(() => {
    // Reset fetch attempt when tab or unread filter changes
    fetchAttemptedRef.current = {};
  }, [activeTab, onlyShowUnread]);

  useEffect(() => {
    if (dropdownIsActive) {
      // queryNotifications();
      fetchNewestNotifications();
    }
  }, [dropdownIsActive]);

  // Set the active tab notifications when the active tab changes
  useEffect(async () => {
    const items = onlyShowUnread ? unreadNotifications : notifications;
    if (activeTab && items && items.length > 0) {
      // Find the types for the active tab
      const activeTypes = notificationGroups.find(group => group.label === activeTab).types;
      // console.log('Active tab:', activeTab, 'Active types:', activeTypes);
      // Filter the notifications based on the active tab types
      const filteredNotifications = items.filter(notification => activeTypes.includes(notification.type));
      setActiveTabNotifications(filteredNotifications);
      // If there are no notifications for the active tab, request more notifications for that group
      if (filteredNotifications.length === 0 && !fetchAttemptedRef.current[activeTab]) {
        // console.log('No notifications for active tab, querying more...', { activeTab, notifications, loading });
        // loadMoreNotifications();
        fetchAttemptedRef.current[activeTab] = true;
        await fetchNotifications({ limit, types: activeTypes });
        // queryNotifications({ types: activeTypes });
      }
    } else {
      // If no active tab, set all notifications
      setActiveTabNotifications([]);
      // setActiveTabNotifications(notifications);
    }
  }, [activeTab, notifications, unreadNotifications, onlyShowUnread]);

  useEffect(() => {
    // If notificationCount is > 0 fetch unread notifications
    if (notificationCount > 0 && dropdownIsActive) {
      const dedupedNotifications = [
        ...new Map([...notifications, ...unreadNotifications].map(item => [item.id, item])).values(),
      ];
      const unreadCount = dedupedNotifications.filter(n => n.isRead === 'false').length;
      // If unreadCount doesn't match notificationCount, fetch unread notifications
      // console.log({ notificationCount, unreadCount, notifications, unreadNotifications });
      if (unreadCount !== notificationCount && unreadNotifications.length === 0) {
        // console.log('Fetching unread notifications...');
        fetchUnreadNotifications();
      }
    }
  }, [notificationCount, unreadNotifications, notifications, dropdownIsActive]);

  // Create a set of tabs based on the notification types
  // Selecting a tab will filter the notifications to only show those of that type
  const messageTabHeader = useCallback(() => {
    const activeClass =
      'bg-white inline-block border-l border-t border-r rounded-t py-2 px-4 font-semibold text-guardian-darkblue';
    const inactiveClass = 'bg-white inline-block py-2 px-4 hover:text-blue-800 font-semibold text-guardian-darkblue';
    return (
      <ul className="flex content-start flex-wrap border-b w-full">
        {/* <ul className="flex border-b w-full"> */}
        {userNotificationGroups.map((group, index) => {
          const dedupedNotifications = [
            ...new Map([...notifications, ...unreadNotifications].map(item => [item.id, item])).values(),
          ];
          const unreadCount =
            dedupedNotifications
              .filter(notification => group.types.includes(notification.type))
              .filter(notification => 'true' !== notification.isRead).length || 0;
          return (
            <li
              className={`${activeTab === group.label ? '-mb-px ' : ''}${
                index !== userNotificationGroups.length - 1 ? 'mr-0' : ''
              } ${loading ? 'cursor-not-allowed text-gray-400' : ''}`}
              key={group.label}>
              <a
                className={
                  (activeTab === group.label ? activeClass : inactiveClass) + ''
                  // (loading ? ' cursor-not-allowed text-gray-400' : ' text-guardian-darkblue')
                }
                onClick={e => {
                  e.preventDefault();
                  resetNextToken();
                  setActiveTab(group.label);
                  // const filteredNotifications = notifications.filter(notification =>
                  //   group.types.includes(notification.type)
                  // );
                  // setNotifications(filteredNotifications);
                }}
                href="#">
                <span className="flex flex-row items-center relative">
                  {group.icon}
                  {group.label}
                  {unreadCount > 0 && (
                    <span className="fa-layers fa-fw absolute" style={{ right: '-0.9em', top: '-0.2em' }}>
                      <span className="fa-layers-counter bg-pursuit-red" style={{ fontSize: 32 }}>
                        {/* 99+ */}
                        {/* Count of notifications for this group */}
                        {/* {notifications
                        .filter(notification => group.types.includes(notification.type))
                        .filter(notification => !notification.readAt).length || 0} */}
                        {unreadCount}
                      </span>
                    </span>
                  )}
                </span>
              </a>
            </li>
          );
        })}
        {/* Add link for "All" notifications which goes to its own page and not a tab */}
        <li className="mr-0" key="all-notifications">
          <a
            className={inactiveClass}
            onClick={e => {
              e.preventDefault();
              // Close the dropdown if it's open
              setDropdownIsActive(false);
              resetNotifications();
              history.push('/notifications');
              fetchNotifications();
            }}
            href="/notifications">
            <span className="flex flex-row items-center">
              <FontAwesomeIcon
                icon={icon({ name: 'list', style: 'solid' })}
                className="text-pursuit-gray text-xl mr-2"
              />
              All
            </span>
          </a>
        </li>
      </ul>
    );
  }, [activeTab, loading, userNotificationGroups, notifications, notificationCount, unreadNotifications]);

  useEffect(() => {
    let subscription = null;

    const initSubscription = async () => {
      try {
        subscription = await API.graphql(graphqlOperation(onNotificationCreated, { recipient: userId })).subscribe({
          error: err => {
            console.error('Error subscribing to onNotificationCreated: ', err);
          },
          next: data => {
            // Update the notifications list with the new notification
            // queryNotifications();
            // console.log('New notification data:', data);
            const newNotification = data.value.data.onNotificationCreated;

            notifications.unshift(newNotification);

            queryNotificationCount();

            // TODO: revisit this logic at a later time to avoid additional queries if possible

            // const existingNotifications = notifications ? [...notifications] : [];

            // if (existingNotifications.length) {
            //   const notification = data.value.data.onNotificationCreated;

            //   const matchingNotification = existingNotifications.find(x => x.id === notification.id);

            //   if (!matchingNotification) {
            //     const updatedNotifications = [...existingNotifications, notification];

            //     const updatedNextToken = {
            //       id: notification.id,
            //       createdAt: notification.createdAt,
            //       recipient: notification.recipient,
            //     };

            //     setNextToken(updatedNextToken);
            //     setNotifications(updatedNotifications);
            //   }
            // }
          },
        });
      } catch (error) {
        console.error('Error on subscription: ', error);
      }
    };

    initSubscription();

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, [notifications, userId, dropdownIsActive]);

  const deactivevateDropDoneOnOutsideClick = event => {
    if (clickOutsideRef.current && !clickOutsideRef.current.contains(event.target)) {
      setTimeout(() => {
        setDropdownIsActive(false);
      }, 100);
    }
  };

  useEffect(() => {
    // document.addEventListener('mousedown', deactivevateDropDoneOnOutsideClick);
    document.addEventListener('mouseup', deactivevateDropDoneOnOutsideClick);

    return () => {
      // document.removeEventListener('mousedown', deactivevateDropDoneOnOutsideClick);
      document.removeEventListener('mouseup', deactivevateDropDoneOnOutsideClick);
    };
  }, [clickOutsideRef]);

  const markAsReadClick = useCallback(
    async notificationId => {
      try {
        const updatedNotification = await markAsRead(notificationId);
        console.log('Updated notification:', updatedNotification);
        // const updatedNotifications = [...notifications].map(n =>
        //   n.id === notificationId ? { ...n, readAt: updatedNotification.readAt } : n
        // );
        // setNotifications(updatedNotifications);
        // setNotifications(prev => prev.map(n => (n.id === notificationId ? { ...n, ...updatedNotification } : n)));
      } catch (error) {
        console.error('Error marking notification as read:', error);
      }
      // setNotificationCount(prevCount => (prevCount > 0 ? prevCount - 1 : 0));
    },
    [notifications, markAsRead]
  );
  const markAsUnreadClick = useCallback(
    async notificationId => {
      try {
        const updatedNotification = await markAsUnread(notificationId);
        console.log('Updated notification:', updatedNotification);
        // const updatedNotifications = [...notifications].map(n =>
        //   n.id === notificationId ? { ...n, readAt: null } : n
        // );
        // setNotifications(updatedNotifications);
        // setNotifications(prev => prev.map(n => (n.id === notificationId ? { ...n, ...updatedNotification } : n)));
        // setNotificationCount(prevCount => prevCount + 1);
      } catch (error) {
        console.error('Error marking notification as unread:', error);
      }
    },
    [notifications, markAsUnread]
  );

  const afterLinkClick = useCallback(link => {
    // console.log('afterLinkClick called with link:', link);
    // If Mobile, close the dropdown
    if (window.innerWidth < 1024) {
      setDropdownIsActive(false);
    }
  }, []);

  const renderDropdown = useCallback(() => {
    return (
      dropdownIsActive && (
        <div
          ref={clickOutsideRef}
          className="absolute mt-4 rounded-md shadow-lg right-0 lg:overflow-visible"
          style={{ maxWidth: '100vw' }}>
          <div className="bg-white rounded-md shadow-xs mx-2 lg:mx-0 lg:w-120 notifications">
            <div className="flex flex-col items-center py-2 max-h-80-screen overflow-y-auto px-2">
              {messageTabHeader()}
              {/* {loading && (
                <div className="flex w-full justify-center items-center">
                  <Spinner />
                </div>
              )} */}

              {!loading && notifications && !notifications.length && (
                <div className="flex w-full justify-center items-center">You have no notifications</div>
              )}
              <div className="notification-list w-full">
                {activeTabNotifications.length === 0 && !fetchAttemptedRef.current[activeTab] && (
                  <div className="flex w-full justify-center items-center">
                    <Spinner />
                  </div>
                )}
    
                {notifications.length > 0 && fetchAttemptedRef.current[activeTab] && activeTabNotifications.length === 0 && (
                  <div className="flex w-full justify-center items-center mt-2">You have no notifications in this category</div>
                )}
                {/* {notifications
                  .filter(notification => {
                    const activeTypes = notificationGroups.find(group => group.label === activeTab).types;
                    return activeTypes.includes(notification.type);
                  }) */}
                {activeTabNotifications.map(notification => (
                  <NotificationRow
                    notification={notification}
                    key={`notification-${notification.id}-${notification.updatedAt}`}
                    // markRead={() => markAsReadClick(notification.id)}
                    // markUnread={() => markAsUnreadClick(notification.id)}
                    markRead={() => markAsRead(notification.id)}
                    markUnread={() => markAsUnread(notification.id)}
                    onAfterLinkClick={afterLinkClick}
                  />
                ))}
              </div>
              <div className="load-more flex w-full items-center mt-2">
                {/* {loading && (
                  <div className="flex-1 justify-center items-center">
                    <Spinner />
                  </div>
                )} */}

                {/* <span className="text-xs text-gray-500 mb-2">
                  Showing {activeTabNotifications.length} 
                </span> */}
                {/* <a onClick={loadMoreNotifications}>Load more</a>{' '}
                <a onClick={toggleOnlyShowUnread}>{onlyShowUnread ? 'Show all' : 'Show unread'}</a>
                 <Switch
                  onChange={enabled => {
                    // setUseVolunteerView(enabled);
                    setOnlyShowUnread(enabled);
                    // history.push('/');
                  }}
                  checked={onlyShowUnread}
                  className="ml-2"
                  height={20}
                  width={40}
                /> */}
                <div className="flex-1 justify-center text-center">
                  <a onClick={loadMoreNotifications} className="cursor-pointer">
                    Load more
                  </a>
                </div>
                <div className="flex-initial flex justify-end items-center">
                  <a onClick={toggleOnlyShowUnread} className="cursor-pointer mr-2">
                    {onlyShowUnread ? 'Show all' : 'Show unread'}
                  </a>
                  <Switch
                    onChange={enabled => {
                      setOnlyShowUnread(enabled);
                    }}
                    checked={onlyShowUnread}
                    className="ml-2"
                    height={20}
                    width={40}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    );
  }, [
    dropdownIsActive,
    clickOutsideRef,
    // notifications,
    // activeTabNotifications,
    loading,
    activeTab,
    messageTabHeader,
    markAsReadClick,
    markAsUnreadClick,
  ]);
  // Change favicon if user has unread messages
  useEffect(() => {
    // console.log({ notificationCount });
    changeFavicon(!!notificationCount);
  }, [notificationCount]);

  const getFormattedNotificationCount = useCallback(() => {
    if (!notificationCount) {
      return null;
    }

    if (notificationCount > 99) {
      return '99+';
    }

    return notificationCount;
  }, [notificationCount]);

  return (
    <div className="lg:relative">
      <button
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          if (!dropdownIsActive) {
            setDropdownIsActive(true);
          }
        }}
        type="button"
        className="flex flex-row items-center focus:outline-none mx-3">
        <div className="relative mx-1 px-2 py-1 lg:mt-2">
          <Icons.FaRegBell className="text-pursuit-gray text-2xl lg:text-4xl" />
          {/* {notificationCount} */}

          {notificationCount ? (
            <>
              <div className="bg-pursuit-red text-pursuit-red animate-ping rounded-full absolute top-0 right-0 text-xs lg:text-sm min-w-4 lg:min-w-5 h-4 lg:h-5 px-1">
                {getFormattedNotificationCount()}
              </div>

              <div className="bg-pursuit-red rounded-full text-white absolute top-0 right-0 text-xs lg:text-sm min-w-4 lg:min-w-5 h-4 lg:h-5 px-1">
                {getFormattedNotificationCount()}
              </div>
            </>
          ) : null}
        </div>
      </button>

      {renderDropdown()}
      {/* {dropdownIsActive && (
        <div ref={clickOutsideRef} className="absolute mt-4 rounded-md shadow-lg right-0 lg:overflow-visible">
          <div className="bg-white rounded-md shadow-xs mx-2 lg:mx-0 lg:w-104 notifications">
            <div className="flex flex-col items-center py-4 h-80 overflow-y-auto px-4">
              {messageTabHeader()}
              {loading && (
                <div className="flex w-full justify-center items-center">
                  <Spinner />
                </div>
              )}

              {!loading && notifications && !notifications.length && (
                <div className="flex w-full justify-center items-center">You have no notifications</div>
              )}
              <div className="notification-list w-full">
                {notifications
                  .filter(notification => {
                    const activeTypes = notificationGroups.find(group => group.label === activeTab).types;
                    return activeTypes.includes(notification.type);
                  })
                  .map(notification => (
                    <NotificationRow
                      notification={notification}
                      key={`notification-${notification.id}`}
                      markRead={() => markAsReadClick(notification.id)}
                      markUnread={() => markAsUnreadClick(notification.id)}
                    />
                  ))}
              </div>
              <div className="load-more">
                <a onClick={loadMoreNotifications}>Load more</a>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default Notifications;
